import { privateAxios } from "../axiosInstances";

export type ExportProVisitorsParams = {
  eventId: string;
  searchText?: string;
};

export const getProVisitorsAsExcel = async ({
  eventId,
  searchText,
}: ExportProVisitorsParams): Promise<Blob> => {
  const { data } = await privateAxios.get<Blob>(
    `/events/${eventId}/pro-visitors/export`,
    {
      responseType: "blob",
      params: { searchText },
    }
  );
  return data;
};
